import { PatcherSet } from "./patcher";

import ldj_012_20231018 from './patcher/patchsets/ldj-012-20231018';
import ldj_010_20231206 from './patcher/patchsets/ldj-010-20231206';
import ldj_012_20240312 from './patcher/patchsets/ldj-012-20240213';
import ldj_010_20240325 from './patcher/patchsets/ldj-010-20240325';
import ldj_010_20240507 from './patcher/patchsets/ldj-010-20240507';
import ldj_012_20240702 from './patcher/patchsets/ldj-012-20240702';

import { Container } from "solid-bootstrap";
import PatcherSetUI from "./components/PatcherSetUI";
import PatcherSetContainer from "./components/PatcherSetContainer";

import './App.css'

export default function () {
  const patcherSets: PatcherSet[] = [
    new PatcherSet("bm2dx.dll", 'LDJ', 2024070200, "012", ldj_012_20240702),
    new PatcherSet("bm2dx.dll", 'LDJ', 2024050700, "010", ldj_010_20240507),
    new PatcherSet("bm2dx.dll", 'LDJ', 2024032500, "010", ldj_010_20240325),
    new PatcherSet("bm2dx.dll", 'LDJ', 2024021300, "012", ldj_012_20240312),
    new PatcherSet("bm2dx.dll", 'LDJ', 2023120600, "010", ldj_010_20231206),
    new PatcherSet("bm2dx.dll", 'LDJ', 2023101800, "012", ldj_012_20231018),
  ];

  return (
    <>
      <Container>
        <PatcherSetContainer patcherSets={patcherSets} />
        {
          patcherSets.map(v => (
            <PatcherSetUI patcher={v} />
          ))
        }
      </Container>
    </>
  )
}
